export default __webpack_public_path__ + "static/media/product_off.26a9cc3b.svg";